import { render } from "./ConfRedirect.vue?vue&type=template&id=478592a7&scoped=true"
import script from "./ConfRedirect.vue?vue&type=script&lang=js"
export * from "./ConfRedirect.vue?vue&type=script&lang=js"

import "./ConfRedirect.vue?vue&type=style&index=0&id=478592a7&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478592a7"]])

export default __exports__